import React, { useContext, useEffect, useState } from "react";
import { useParams } from "react-router-dom";

import { Button, Container } from "@mui/material";

import ChildView from "../shared/ChildView";
import { AppContext } from "../Store";
import { IChild } from "../shared/types/child";

const ChildPage: React.FC = () => {

  const { childId } = useParams<{ childId: string }>();

  const context = useContext(AppContext);
  const { childrenData } = context;


  const [child, setChild] = useState<IChild>();


  useEffect(() => {
    if (!childrenData) return;
    const child = childrenData.find((child) => child.id === childId);
    setChild(child);
  }, [childrenData]);

  return (
    <Container
      maxWidth="lg"
      style={{
        display: "flex",
        minHeight: "100vh",
      }}
    >
      {child && (
        <ChildView child={child} />
      )}

      {!child && (
        <React.Fragment>
          <Button variant="contained" color="primary">
            Go Back
          </Button>
        </React.Fragment>
      )}
    </Container>
  );
};

export default ChildPage;
